import { Typography } from '@iheartjane/reefer';
import type { MarginProperties } from '@iheartjane/reefer';

import { JaneGoldLearnMoreLink } from '../janeGoldLearnMoreLink/janeGoldLearnMoreLink';

export const OhioGoldEducation = ({
  learnMoreLink,
  userHasLinkedBank,
  ...spacing
}: {
  learnMoreLink?: React.ReactNode;
  userHasLinkedBank?: boolean;
} & MarginProperties) => {
  return (
    <Typography {...spacing}>
      Veterans, indigent medical patients, and deal-seekers can use Jane Gold to
      get the best price on select products.{' '}
      {learnMoreLink ?? (
        <JaneGoldLearnMoreLink userHasLinkedBank={userHasLinkedBank} />
      )}
    </Typography>
  );
};
